var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactDetailsSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#5B73E8",
    fillOpacity: 0.1,
    stroke: "#5B73E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5813_3981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1821 17.5122L8 20.0732V8.73171C8 8.53765 8.07525 8.35153 8.20921 8.21431C8.34316 8.07709 8.52485 8 8.71429 8H19.4286C19.618 8 19.7997 8.07709 19.9336 8.21431C20.0676 8.35153 20.1429 8.53765 20.1429 8.73171V17.5122H11.1821ZM10.6879 16.0488H18.7143V9.46341H9.42857V17.0622L10.6879 16.0488ZM13 18.9756H20.3121L21.5714 19.989V12.3902H22.2857C22.4752 12.3902 22.6568 12.4673 22.7908 12.6046C22.9247 12.7418 23 12.9279 23 13.122V23L19.8179 20.439H13.7143C13.5248 20.439 13.3432 20.3619 13.2092 20.2247C13.0753 20.0875 13 19.9014 13 19.7073V18.9756Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5813_3981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDetailsSms);
export default __webpack_public_path__ + "static/media/ContactDetailsSms.60426f89f26fc1f29937da19d4d713b4.svg";
export { ForwardRef as ReactComponent };